export default async function getOperatingSystem() {
  if ('userAgentData' in navigator && navigator.userAgentData) {
    const uaData = await navigator.userAgentData.getHighEntropyValues(
      ['platformVersion'],
    );
    localStorage.setItem('deviceOS', uaData.platform);
    return uaData.platform;
  }
  return '';
}
